<mat-card>
	<mat-card-title>
		<h2>{{title|translate}}</h2>
	</mat-card-title>
</mat-card>	